
// @ts-ignore
// import firebaseConfig from "../../config/firebase.ts";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAZv0CcZYeM3pU44hRkVsFI-PII4nb8weE",
  authDomain: "xceptia.firebaseapp.com",
  projectId: "xceptia",
  storageBucket: "xceptia.appspot.com",
  messagingSenderId: "84106424344",
  appId: "1:84106424344:web:f8bdf828da550f4b3e136d",
  measurementId: "G-YT65STDK8E"
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
const analytics = getAnalytics(firebaseApp);



const db = getFirestore(firebaseApp);
const storage = getStorage(firebaseApp)

export { db, storage };